<template>
  <v-tooltip
    v-if="tooltip"
    location="top"
    max-width="520"
    :open-delay="200"
    content-class="nontax-diff-tooltip-wrap"
  >
    <template #activator="{ props: tipProps }">
      <span v-bind="tipProps" class="diff-tooltip-target">{{ text }}</span>
    </template>
    <div class="nontax-diff-tooltip">{{ tooltip }}</div>
  </v-tooltip>
  <span v-else>{{ text }}</span>
</template>

<script setup lang="ts">
defineProps<{
  text: string;
  tooltip?: string;
}>();
</script>
